var AbstractPlayerTech    = require("./AbstractPlayerTech"),
    ReaderProgressTracker = require("app/MediaPlayer/ProgressTrackers/ReaderProgressTracker"),
    kind                  = require("enyo/kind"),
    logger                = require("enyo/logger");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.Astract.AbstractReader.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.Astract.AbstractReader",

    /**
     * @private
     */
    kind: AbstractPlayerTech,

    /**
     * @private
     */
    classes: "app-media-player-reader",

    // Common Components
    // --------------------------------

    /**
     * The tracker kind to use.
     *
     * @type  {Function}
     * @public
     */
    trackerKind: ReaderProgressTracker,

    // Internal State
    // --------------------------------

    /**
     * Use this value to determine if the reader is ready to seek.
     *
     * @type    {boolean}
     * @default false
     * @private
     */
    isSeekable: false,

    /**
     * Current page position within content.
     *
     * @type  {?number}
     * @public
     */
    page: null,

    /**
     * This value indicates whether the reader has reached the startPage.
     *
     * @type     {boolean}
     * @default  false
     * @public
     */
    hasStarted: false,

    /**
     * Resets reader to the state of an uninitialized reader.
     *
     * @private
     */
    resetReaderState: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.set("page", null);
            this.set("hasStarted", false);
            this.set("isSeekable", false);
        };
    }),

    // Reader Events
    // --------------------------------

    /**
     * @public
     */
    events: {
        onMediaPlayerError: ""
    },

    // Reader API
    // --------------------------------

    /**
     * The following methods *must* be implemented in order for the reader to be
     * compatible with the rest of the application.
     */

    /**
     * Hide the controls (this may not be possible for every reader).
     *
     * @returns  {boolean}  `true` if hidden, `false` otherwise.
     * @public
     */
    hideControls: function() {
        return false;
    },

    /**
     * Show the controls (this may not be possible for every reader).
     *
     * @returns  {boolean}  `true` if showing, `false` otherwise.
     * @public
     */
    showControls: function() {
        return false;
    },

    /**
     * Move to a certain page position
     *
     * @param  {number}  page  The page position to seek to
     *
     * @public
     */
    seek: function() {
        var errorMsg = "app.MediaPlayer.Tech.Astract.AbstractReader.seekToAndPlay(page) not implemented";

        logger.warn(errorMsg);

        if (typeof Sentry !== "undefined") {
            Sentry.captureException(new Error(errorMsg));
        }
    },

    /**
     * Return the current page displayed by the reader.
     *
     * @returns  {number?}  The page if available, `null` otherwise.
     * @public
     */
    getCursor: function() {
        var errorMsg = "app.MediaPlayer.Tech.Astract.AbstractReader.getCursor() not implemented";

        logger.warn(errorMsg);

        if (typeof Sentry !== "undefined") {
            Sentry.captureException(new Error(errorMsg));
        }

        return null;
    },

    /**
     * Return the length in pages of the current content.
     *
     * @returns  {number?}  The length if available, `null` otherwise.
     * @public
     */
    getLength: function() {
        var errorMsg = "app.MediaPlayer.Tech.Astract.AbstractReader.getLength() not implemented";

        logger.warn(errorMsg);

        if (typeof Sentry !== "undefined") {
            Sentry.captureException(new Error(errorMsg));
        }

        return null;
    }

});
